import { post } from '@/utils/network/axios-helper';
import type { IParamsType } from '@/utils/ctype';
import type { ISaveWritingAnswerList, IWritingContent } from './type';

export const getWritingContent = (params: IParamsType) => {
  return post<IWritingContent>('/api/simulate/get-writing-info', params);
};

export const getAnswerList = (params: IParamsType) => {
  return post('/api/simulate/get-writing-draft-info', params);
};

export const saveAnswerList = (params: ISaveWritingAnswerList) => {
  return post('/api/simulate/save-writing-info', params);
};

export const submitAnswer = (params: IParamsType) => {
  return post('/api/simulate/finished-writing', params);
};